module.exports = __webpack_public_path__ + "static/dorishowe2-1a89d6a0b15750f73b73a7d7abf58c74.png";